import config from '@/config'
import axios from 'axios'
import { store } from '@/store/store'
import router from '@/router'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import Swal from 'sweetalert2';

axios.defaults.timeout = 60000
export default {
  authDefault: function(creds, callback) {
    let url = 'adminlogin'
    if (creds.userid == 'zwizadmin') {
      url += `?limit=100&offset=${creds.offset}`
      if (creds.pagename) url += `&pagename=${creds.pagename}`
    }
    axios
      .post(config.serverUrl + url, {
        userid: creds.userid,
        password: creds.password,
        'g-recaptcha-response': creds['g-recaptcha-response']
      })
      .then(response => {
        response = response.data
        if (response.responsecode === 200) {
          callback(null, response)
        } else if (response.responsecode === 400) {
          let message = response.reason ? response.reason : 'Something went wrong, please try again'
          store
            .dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            .then(function() {
              router.push('/' + store.getters.currentLang + '/nigol')
            })

          // router.push('/nigol')
          callback(new Error(message))
        } else {
          if (response.reason) {
            callback(new Error(response.reason))
          } else {
          }
        }
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLongLiveToken: function(creds, callback) {
    axios
      .post(config.serverUrl + 'getlonglivetoken', {
        appid: config.appid,
        accesstoken: creds.accessToken
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  async getPageList(data) {
    let url =
      'https://graph.facebook.com/v4.0/me/accounts?access_token=' +
      data.token +
      '&limit=' +
      (data.limit || 1000) +
      '&fields=access_token,category,category_list,id,tasks,name,name_with_location_descriptor'
    if (data.url) {
      url = data.url
    }
    try {
      let response = await axios.get(url)
      // JSON responses are automatically parsed.
      response = response.data
      if (response.data) {
        let pagelist = []
        try {
          pagelist = response.data
            .map(value => {
              var page = cloneDeep(value)
              page.channel = 'fb'
              page.name = page.name_with_location_descriptor
              return page
            })
            .filter(el => el != null)
        } catch (error) {
          throw error
        }
        let next = null
        if (response.paging && response.paging.next) next = response.paging.next
        return { pages: pagelist, is_next: next }
      } else {
        return { pages: [] }
      }
    } catch (error) {
      throw error
    }
  },
  getPostData: function(data, callback) {
    axios
      .get(
        `https://graph.facebook.com/${data.postid}?access_token=` +
          store.state.selectedBot.page_access_token
      )
      .then(response => {
        // JSON responses are automatically parsed.
        // var response = response.data
        if (response) {
          callback(null, response)
        } else {
          callback(new Error(response.reason))
        }
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  getAllPublicTheme: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallpublictheme?appid=' + data.appid)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProducts: function(data, callback) {
    let url = config.serverUrl + 'products'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getCountSpecialCategory: function(pageNumber, callback) {
    let url = config.serverUrl + 'page/' + pageNumber + '/count-special-category'
    axios.defaults.headers.common = { AUTHORIZATION: store.getters.securityToken }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getCategories: function(data, callback) {
    let url = config.serverUrl + 'categories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'products', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'products?id=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProductStatus: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productsstatus?id=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(
        config.serverUrl + 'products?id=' + data + `&pageid=${store.getters.selectedBot.pageid}`
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSignedRequest: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'sign-s3-v2?file-name=' + data.name + '&file-type=' + data.type

    axios
      .get(url)
      .then(response => {
        // JSON responses are automatically parsed.
        var response = response.data
        response.file = data.file
        this.uploadfile(response, function() {
          callback(null, response.url)
        })
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },
  getSignedRequestV1: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'sign-s3?file-name=' + data.name + '&file-type=' + data.type

    axios
      .get(url)
      .then(response => {
        // JSON responses are automatically parsed.
        var response = response.data
        response.file = data.file
        this.uploadfileV1(response, function() {
          callback(null, response.url)
        })
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  uploadfileV1: function(data, callback) {
    let signedRequest = data.signedRequest
    let request = data.file
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', signedRequest)
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
    xhr.send(request)
  },

  // -------------   V2    ----------------
  uploadfile: function(data, callback) {
    let signedRequest = data.signedRequest
    const formData = new FormData()
    formData.append('acl', 'public-read')
    Object.keys(signedRequest.fields).forEach(key => {
      formData.append(key, signedRequest.fields[key])
    })

    // Actual file has to be appended last.
    formData.append('file', data.file)
    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    const xhr = new XMLHttpRequest()
    xhr.open('POST', signedRequest.url, true)
    xhr.send(formData)
    xhr.onload = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 204) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
  },

  saveCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'categories', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editCategory: function(data, callback) {
    let request = {
      name: data.name,
      display_name: data.display_name,
      is_hidden: data.is_hidden
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'categories?id=' + data.id, request)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'categories?id=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveSubCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'subcategories', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteSubCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'subcategories?id=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editSubCategory: function(data, callback) {
    let request = {
      name: data.name
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'subcategories?id=' + data.id, request)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProductStock: function(productid, callback) {
    let url = config.serverUrl + 'productstock?productid=' + productid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productstock?productid=' + data.productid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productstock?productstockid=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'productstock?productstockid=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  newSubscribe: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'newsubscribe', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  unSubscribe: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'unsubscribe', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAllUsers: function(data, callback) {
    let url = config.serverUrl + 'getallusers'
    var body = {
      ...data,
      ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, body)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  multicast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'multicast', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  toggleBotStatus: function(data, callback) {
    let url = !data.status ? 'stopbot' : 'startbot'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  checkBotlist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  checkBotlistPrimary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'checkbotlist', { ...data, is_db_primary: true })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWelcomeMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'botwelcomemessage', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWelcomeMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'botwelcomemessage?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLiveChatUsers: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(`${config.serverUrlAws}v2/getuserthread`, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUserMessages: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        `
        ${config.serverUrlAws}getchatlog?userid=${data['userid']}&limit=${data['limit']}&offset=${
          data['offset']
        }&pageid=${data['pageid']}&app=${data['app']}${
          data['is_without_error'] ? '&is_without_error=true' : ''
        }`
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUserMessagesGroup: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'livechat/' + data['pageid'] + '/line/' + data['groupId'] + '/chat', {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  sendMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendmessage', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        console.log('error', e)
        // this.defaultError(e, callback)
      })
  },

  endSessionChat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'endconversation', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  openSessionChat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'startconversation', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        `${config.serverUrl}intents?pageid=${data['pageid']}&limit=${data['limit'] ||
          ''}&offset=${data['offset'] || ''}&page_intent=${data['page_intent'] ||
          ''}&search_intent=${data['search_intent'] || ''}&sort_by=${data['sort_by'] ||
          ''}&sort_type=${data['sort_type'] || ''}&intent_name=${data['intent_name'] ||
          ''}&intent_status=${data['intent_status'] || ''}`
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getIntentBecon: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'line-beacon/' + data['pageid'] + '/campaign')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  addIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'intents', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  addIntentBecon: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'line-beacon/' + data['pageid'] + '/campaign', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'intents?id=' + data['id']

    if (data['noUpdatedAt']) {
      url += `&no_updated_at=${data['noUpdatedAt']}`
    }

    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editIntentBecon: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'line-beacon/' + data['pageid'] + '/campaign/' + data['id'], data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'intents', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteIntentBecon: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'line-beacon/' + data['pageid'] + '/campaign/' + data['id'], data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardSummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url = config.serverUrl + 'pagereport_summary'

    axios
      .get(url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_intents?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    if (data.group) {
      url += '&intentgroup=' + data.group
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardActiveUserByDate: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_activeusers_bydate?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardActiveUserByTime: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_activeusers_bytime?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto'] +
      '&time_0=' +
      data['time_0'] +
      '&time_1=' +
      data['time_1']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getdashbroadshopanalytic(data, callback) {
    var url = config.serverUrl + `salesreport?`
    url +=
      'datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] + '&pageid=' + data['pageid']

    if (data['channel'] && data['channel'] !== 'all') {
      url += '&channel=' + data['channel']
    }

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getOrderSummary: function(data, callback) {
    var url = config.serverUrl + `ordersummary`
    var headers = {}
    if (data.pageid && data.pageid != '' && data.pageid != null) {
      // url += 'pageid=' + data['pageid']
      headers = {
        AUTHORIZATION: store.getters.securityToken
      }
    } else if (data.lineid && data.lineid != '' && data.lineid != null) {
      // url += 'lineid=' + data['lineid']
    }
    // url +=
    // '&datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] + '&status=' + data['status']

    axios
      .get(url, { params: data, headers: headers })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editOrderSummary: function(data, callback) {
    var url = config.serverUrl + 'ordersummary?'
    if (data.lineid && data.lineid != '' && data.lineid != null) {
      url += 'lineid=' + data['lineid'] + '&pageid=' + data['pageid']
    } else if (data.pageid && data.pageid != '' && data.pageid != null) {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      url += 'pageid=' + data['pageid']
    }
    url += '&id=' + data.id
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getShopProfile: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shopprofile?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editShopProfile: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'shopprofile?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineNotifySubscriber: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'notifyadminuser?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteLineNotifySubscriber: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(
        config.serverUrl +
          'notifyadminuser_remove?pageid=' +
          data['pageid'] +
          '&userid=' +
          data['userid'],
        data
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  sendMessageLine: function(data, callback) {
    axios
      .post(config.serverUrl + 'sendmessageline', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getChatlogLine: function(data, callback) {
    axios
      .get(
        `${config.serverUrlAws}getchatlog?userid=${data['userid']}&adminid=${data['adminid']}&pageid=${data['pageid']}&limit=${data['limit']}&offset=${data['offset']}`
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getChatUsersLine: function(data, callback) {
    // axios.defaults.headers.common = {
    // 	'AUTHORIZATION': store.getters.securityToken
    // };
    axios
      .get(
        config.serverUrl +
          'getuserthread?pageid=' +
          data['pageid'] +
          '&app=' +
          data['app'] +
          '&inbox=' +
          data['type'] +
          '&limit=' +
          data['limit'] +
          '&offset=' +
          data['offset']
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPaypalUrl: function(data, callback) {
    axios
      .get(config.serverUrl + 'getpaypal_registerurl')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPaypalTrackingStatus: function(data, callback) {
    axios
      .get(config.serverUrl + 'getpaypal_trackingstatus?tracking_id=' + data['tracking_id'])
      .then(response => {
        // this.defaultResponse(response, callback)
        callback(null, response.data)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updatePaypalMerchantId: function(data, callback) {
    // paypal_merchantid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'updatepaypal_merchantid?pageid=' + data['pageid'], data)
      .then(response => {
        callback(null, response.data)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSetting: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallcontent?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getBotDetail: function(data, callback) {
    // console.log(store.getters.securityToken)
    if (!data['pageid']) {
      return false
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'checkbotpage?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPersistentMenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'getmessenger_profile', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editPersistentMenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url = config.serverUrl + 'messenger_profile'
    // delete data.pageid
    // delete data.status
    // delete data.access_token
    axios
      .post(url, { ...data, fields: 'persistent_menu' })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTraningConversation: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrlAws + 'defaultchatlogs', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateTrainingConversation: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'updatedefaultchatlogs', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putupdateTrainingConversation: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'updatedefaultchatlogs', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateConfig: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'updateadminconfig', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getBroadcast: function(data, callback) {
    let url = config.serverUrl + 'getbroadcast'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  estimateReach: function(data, callback) {
    // if (data.filter.messagesent.value) {
    //   data.filter.messagesent = (data.filter.messagesent.symbol.value + data.filter.messagesent.value)
    // }
    // let url = `${config.serverUrlAws}estimatereach`
    let url = `${config.serverUrl}zwiz-api/estimatereach`
    if (data.data['filter'] && store.getters.getPackage == 'premium') {
      var body = {
        ...data.data,
        ...this.joinFilterToObject(data.data['filter'], store.getters.getPackage == 'premium')
      }
    } else {
      var body = data.data
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, body, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  collectexportcustomersanalytic(data, callback) {
    let url = config.serverUrl + 'collectexportcustomersanalytic?pageid=' + data.pageid
    if (data['filter'] && store.getters.getPackage == 'premium') {
      url += '&' + this.joinFilter(data['filter'], true)
    } else if (data['condition']) {
      url += data['condition']
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putcollectexportcustomersanalytic(data, callback) {
    let url = config.serverUrl + 'collectexportcustomersanalytic'

    var body = {
      ...data,
      ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, body)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateBroadcast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    if (data['filter']) {
      var filter = ''
      filter += this.joinFilter(data['filter'], true)
      data.m_condition = filter
    }
    axios
      .post(config.scheduleUrl + 'savebroadcast', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteBroadcast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'deletebroadcast', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTutoriallist: function(callback) {
    let url = config.serverUrl + 'tutoriallist'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateTutoriallist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'tutoriallist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProductBundle: function(data, callback) {
    let url = config.serverUrl + 'productbundle?productid=' + data.id
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productbundle?productid=' + data.productid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  editProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productbundle?productbundleid=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'productbundle?productbundleid=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getGbprime: function(data, callback) {
    let url = config.serverUrl + 'gbprime?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveGbprime: function(data, callback) {
    let url = config.serverUrl + 'gbprime?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineToken: function(data, callback) {
    let url = config.serverUrl + 'linetoken?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineToken: function(data, callback) {
    let url = config.serverUrl + 'linetoken?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  checkGBprimeToken: function(data) {
    return new Promise((resolve, reject) => {
      var request = {
        token: data.token,
        amount: '1',
        referenceNo: new Date().getTime(),
        payType: 'F',
        cardUse: 'Y',
        billUse: 'Y',
        qrUse: 'Y',
        expire: '1',
        deliveryMethod: '0',
        multipleUse: 'N',
        detail: 'Check Valid Token'
      }
      axios
        .post('https://api.gbprimepay.com/gbp/gateway/link', request)
        .then(response => {
          if (response.data.gbLinkUrl !== undefined) {
            resolve()
          } else {
            reject(new Error('Something wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getPublishedPost: function(fburl) {
    return new Promise((resolve, reject) => {
      let pageid = store.state.selectedBot.facebook_page_id || store.state.selectedBot.pageid
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/v4.0/' +
          pageid +
          '/posts?access_token=' +
          store.state.selectedBot.page_access_token
      }
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getSchedulePost: function(fburl) {
    return new Promise((resolve, reject) => {
      let pageid = store.state.selectedBot.facebook_page_id || store.state.selectedBot.pageid
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/v4.0/' +
          pageid +
          '/scheduled_posts?access_token=' +
          store.state.selectedBot.page_access_token
      }
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  saveUserStatus: function(data, callback) {
    let url = config.serverUrl + 'userstatus?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUserStatus: function(data, callback) {
    let url = config.serverUrl + 'userstatus?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserEmail: function(data, callback) {
    let url = config.serverUrl + 'useremail?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserPhoneno: function(data, callback) {
    let url = config.serverUrl + 'userphoneno?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserTags: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'usertags?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserProvince: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userprovince?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserLineId: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userlineid?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserSchool: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userschool?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWholesaleStatus: function(data, callback) {
    let url = config.serverUrl + 'wholesale_status?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWholesaleStatus: function(data, callback) {
    let url = config.serverUrl + 'wholesale_status?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?wholesaleid=' + data.wholesaleid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?wholesaleid=' + data.wholesaleid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPauseStatus: function(data, callback) {
    let url = config.serverUrl + 'notreplyduplicateintent?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  togglePauseStatus: function(data, callback) {
    let url = config.serverUrl + 'notreplyduplicateintent?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getReplyDelay: function(data, callback) {
    let url = config.serverUrl + 'replydelay?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editReplyDelay: function(data, callback) {
    let url = config.serverUrl + 'replydelay?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineNotify: function(data, callback) {
    let url = config.serverUrl + 'linenotify?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineNotify: function(data, callback) {
    let url = config.serverUrl + 'linenotify'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteLineNotify: function(data, callback) {
    let url =
      config.serverUrl + 'linenotify?pageid=' + data['pageid'] + '&adminid=' + data['adminid']
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineNotifyNotification: function(data, callback) {
    let url = config.serverUrl + 'notifications?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getCompareIntents: function(data, callback) {
    let url = config.serverUrl + 'compareintents'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getCompareAdsSimulator: function(data, callback) {
    let url = `${config.serverUrl}page/${data.pageid2}/compare-messenger-ads-simulator?from_page_id=${data.pageid1}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSupportUser: function(data, callback) {
    let url = config.serverUrl + 'supportusers?supportusers=' + data.supportusers
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  transferIntents: function(data, callback) {
    let url = config.serverUrl + 'cloneintents?pageid1=' + data.pageid1 + '&pageid2=' + data.pageid2

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveSupportusers: function(data, callback) {
    let url = config.serverUrl + 'supportusers?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAllShipingCharge: function(data, callback) {
    let url = config.serverUrl + 'allshipingcharge?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveAllShipingCharge: function(data, callback) {
    let url = config.serverUrl + 'allshipingcharge?pageid=' + data.pageid
    delete data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  insertUsersFromInbox: function(data, callback) {
    let url = config.serverUrl + 'insertusersfrominbox?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  insertUsersFromDone: function(data, callback) {
    let url = config.serverUrl + 'insertusersfromdone?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTimeToUseBot: function(data, callback) {
    let url = config.serverUrl + 'timetousebot?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveTimeToUseBot: function(data, callback) {
    let url = config.serverUrl + 'timetousebot?pageid=' + data.pageid
    delete data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getVideoList: function() {
    return new Promise((resolve, reject) => {
      let pageid = store.state.selectedBot.facebook_page_id || store.state.selectedBot.pageid
      let url =
        'https://graph.facebook.com/v4.0/' +
        pageid +
        '/video_lists?access_token=' +
        store.state.selectedBot.page_access_token
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getVideo: function(url) {
    return new Promise((resolve, reject) => {
      let pageid = store.state.selectedBot.facebook_page_id || store.state.selectedBot.pageid
      if (!url) {
        url =
          'https://graph.facebook.com/v4.0/' +
          pageid +
          '/videos?access_token=' +
          store.state.selectedBot.page_access_token +
          '&fields=permalink_url,title,description,source,id,picture,length'
      }

      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getWordAfterOrderAndCartSummary: function(data, callback) {
    let url = config.serverUrl + 'wordsafterordersandcartsummary?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWordAfterOrderAndCartSummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'wordsafterordersandcartsummary?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminTasks: function(data, callback) {
    let url = config.serverUrl + 'astonadmintasks'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAstonAdminTasksOutsource: function(data, callback) {
    let url = config.serverUrl + 'astonadmintasksoutsource'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAstonAdminTasksLine: function(data, callback) {
    let url = config.serverUrl + 'astonadmintasksline'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonTagOrderFromAds: function(data, callback) {
    let url = config.serverUrl + 'astontagorderfromads'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonRefIdOrderDetail: function(data, callback) {
    let url = config.serverUrl + 'astonrefidorderdetail'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonCloseTasksPerAdmin: function(data, callback) {
    let url = config.serverUrl + 'astonclosetasksperadmin'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAstonCloseTasksPerAdminOutsource: function(data, callback) {
    let url = config.serverUrl + 'astonclosetasksperadminoutsource'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminUserDetails: function(data, callback) {
    let url = config.serverUrl + 'astonadminuserdetails'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminUserUserGroupByWord: function(data, callback) {
    let url = config.serverUrl + 'astonadminusergroupbyword'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getKetshopToken: function(data, callback) {
    let url = config.serverUrl + 'ketshop_shoptoken'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveKetshopToken: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(`${config.serverUrl}ketshop_shoptoken?pageid=${data.pageid}`, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUser: function(data, callback) {
    let url = config.serverUrl + 'getuser'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getUserOnly: function(data, callback) {
    let url = config.serverUrl + 'getuseronly'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getUserOnlyGroup: function(data, callback) {
    let url =
      config.serverUrl + `livechat/${store.state.selectedBot.pageid}/line/${data.group_id}/info`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveAstonUpdateAdminTasks: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'astonupdateadmintasks', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getbudashboardregisterquestion: function(data, callback) {
    let url = config.serverUrl + 'budashboardregisterquestion'
    let params = data.start ? { dateFrom: data.start, dateTo: data.end } : {}
    Object.assign(params, { pageid: data.pageid })
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getbudashboardfaculty: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        config.serverUrl +
          `budashboardfaculty?dateFrom=${data.start}&dateTo=${data.end}&pageid=${data.pageid}`
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getbudashboardscholarships: function(data, callback) {
    let url = config.serverUrl + 'budashboardscholarships'
    let params = data.start ? { dateFrom: data.start, dateTo: data.end } : {}
    Object.assign(params, { pageid: data.pageid })

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  activateredeemcode(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(
        config.serverUrl + 'activateredeemcode?pageid=' + data.pageid + '&redeemcode=' + data.redeem
      )
      .then(response => {
        callback(null, response.data)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putchangebotstate: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'changebotstate?pageid=' + data.pageid, data.input)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getschoollist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'schoollist')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  astonaveragespeedofanswer(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'astonaveragespeedofanswer', {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getastonqacustomerservice(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'astonqacustomerservice', {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putastonqacustomerservice: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'astonqacustomerservice', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getastonqaadminchatlog(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'astonqaadminchatlog', {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putastonqaadminchatlog: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'astonqaadminchatlog', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putQvalIntents: function(request, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'qvalintents', request.data, { params: request.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  // multistatusordersummary?pageid=....&orderidlist=.....&statusorder=......
  putmultistatusordersummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `v2/multistatusordersummary?pageid=${data.pageid}`, {
        orderidlist: data.orderid.toString(),
        statusorder: data.status
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putprioritycategories: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `prioritycategories?pageid=${data.pageid}`, {
        categorieslist: data.input
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putpriorityproducts: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `priorityproducts?pageid=${data.pageid}`, {
        productslist: data.input
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postUpdateProductPriority: function(data, callback) {
    let url = config.serverUrl + 'page/' + data.pageid + '/update-product-priority'
    axios.defaults.headers.common = { AUTHORIZATION: store.getters.securityToken }
    axios
      .post(url, data.input)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getcompareshopservice: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `compareshopservice?pageid1=${data.pageid1}&pageid2=${data.pageid2}`)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  transfershopservice: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(
        config.serverUrl + `transfershopservice?pageid1=${data.pageid1}&pageid2=${data.pageid2}`,
        data
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveUserContext: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `usercontext?pageid=${data.pageid}`, {
        context: data.context,
        userid: data.usersid
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveUserNote: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `usernote?pageid=${data.pageid}`, {
        note: data.context,
        usersid: data.usersid
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  zwizadminbotlist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `zwizadminbotlist?limit=${data.limit}&offset=${data.offset}`
    if (data.pagename) url += `&pagename=${data.pagename}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getuserCustomer: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getuser`
    axios
      .get(config.serverUrl + url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getuserCustomerOnly: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getuseronly?pageid=${data.pageid}&userid=${data.userid}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getInfocustomerspremium: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `infocustomerspremium?pageid=${data['pageid']}&type=${data.type}&package=${data.package}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postInfocustomerspremium: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `infocustomerspremium?pageid=${data['pageid']}&package=${data.package}`
    axios
      .post(config.serverUrl + url, data.obj)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  collectlineidpremiumextra: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `collectlineidpremiumextra?pageid=${data['pageid']}`
    axios
      .put(config.serverUrl + url, data.obj)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  productstockadd: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstockadd?productstockid=${data['productstockid']}`
    axios
      .put(config.serverUrl + url, { addquantity: data.quantity })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  productstockdelete: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstockdelete?productstockid=${data['productstockid']}`
    axios
      .put(config.serverUrl + url, { deletequantity: data.quantity })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  orderstockadd: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    const orderid = data['orderid'] ? 'orderid=' + data['orderid'] : ''
    const orderids = data['orderids'] ? 'orderids=' + data['orderids'] : ''
    let url = `orderstockadd?${orderid}${orderids}`
    axios
      .put(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  orderstockdelete: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orderstockdelete?orderid=${data['orderid']}`
    axios
      .put(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putauctionfbpost: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost?id=${data['id']}`
    axios
      .put(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postauctionfbpost: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost`
    axios
      .post(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getauctionfbpost: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost?pageid=${data['pageid']}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  checkChatdayToken: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'chatdaytoken', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getadminperformbypageid: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `adminperformbypageid`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getPartnerProfile: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnerprofile`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getPartnerRedeemCode: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnerredeemcode`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getPartnerCustomers: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnercustomers`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getNeoMoneyDashboard: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `neomoneydashboard`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getLatestSupportUsers: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `latestsupportusers`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getproductlive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productlive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putproductlive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productlive', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postproductlive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productlive', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postliveinfo: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'liveinfo', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postsendordersummaryall: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendordersummaryall', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putchangeproductlivestatus: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'changeproductlivestatus', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postsendordersummarybyuser: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendordersummarybyuser', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postproductstocklive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productstocklive', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putliveinfo: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'liveinfo', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putproductstocklive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productstocklive', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putcartsummarypattern: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'cartsummarypattern', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putcartsummarypatternstatus: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'cartsummarypatternstatus', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postuploadproducts: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    if (data.isCentral) {
      if (store.state.centralPage.includes(store.state.selectedBot.pageid)) {
        var url = 'v2/uploadcentralproducts'
      } else {
        var url = 'uploadcentralproducts'
      }
    } else {
      var url = 'uploadzwizproducts'
    }
    axios
      .post(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteproductlive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productlive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteproductstocklive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstocklive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getliveinfo: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfo`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getliveinfoHistory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfo_history`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getliveinfodetail: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfodetail`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getchatstat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `chatstat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getorderstat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orderstat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  gettoporderslive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `toporderslive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getordersummarylive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `ordersummarylive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getexportcmsviewcarts: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `exportcmsviewcarts`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteliveinfo: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfo`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getusercartslive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `usercartslive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getcartsummarypattern: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `cartsummarypattern`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteclearcartslive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `clearcartslive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getcmsviewcarts: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `cmsviewcarts`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getusercart: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `usercart`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getordersbyid: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `ordersbyid`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveSlip: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'ordersummarynote', data.data, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteAllInCart(data, callback) {
    axios
      .delete(config.serverUrl + 'cmsviewcarts', {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        data: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getastonconversationrateperadmin: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `v2/astonconversationrateperadmin`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getgetstartedmenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getstarted_menu`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  savegetstartedmenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'getstarted_menu', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserAddress: function(data, callback) {
    let url = config.serverUrl + 'useraddress?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  changepasswordadminuser(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'changepasswordadminuser', { password: data.password })

      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  savefbpaystatus(data, callback) {
    let url = config.serverUrl + 'fbpaystatus'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  adminreadchat(data, callback) {
    let url = config.serverUrl + 'adminreadchat'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getpromotioncode: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `promotioncode`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  savepromotioncode(data, callback) {
    let url = config.serverUrl + 'promotioncode'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data.data, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editpromotioncode: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'promotioncode', data.data, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deletepromotioncode(data, callback) {
    axios
      .delete(config.serverUrl + 'promotioncode', {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getchatlogthaiunionformat(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `chatlogthaiunionformat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  livechatnotiunread(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `v2/livechatnotiunread`
    axios
      .get(`${config.serverUrlAws}${url}`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getbranchlocation(data, callback) {
    let url = `branchlocation`
    axios
      .get(config.serverUrl + url, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  savebranchlocation(data, callback) {
    let url = config.serverUrl + 'branchlocation'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getGroupDefaultChatlogs: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .post(
        config.serverUrlAws +
          (data.type == 'inbox' ? 'report_inbox_message_detail' : 'report_comment_message_detail'),
        data
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getshippop(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippop', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  superjeewrankedvoting: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrl + 'superjeewrankedvoting', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        callback(e)
      })
  },
  saveshippop(data, callback) {
    let url = config.serverUrl + 'shippop'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  shippopcheckorderlist(data, callback) {
    let url = config.serverUrl + 'shippopcheckorderlist'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  shippopbooking(data, callback) {
    let url = config.serverUrl + 'shippopbooking'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  shippopconfirm(data, callback) {
    let url = config.serverUrl + 'shippopconfirm'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  shippopbookingrefno(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippopbookingrefno', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  superjeewrankedvotingBycompetitorid: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrl + 'superjeewrankedvotingBycompetitorid', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getgbprimecredit(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'gbprimecredit', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  savegbprimecredit(data, callback) {
    let url = config.serverUrl + 'gbprimecredit'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getakita(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'akitatoken', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveakita(data, callback) {
    let url = config.serverUrl + 'akitatoken'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  gbcreaterefnofromupgradepremiumcms(data, callback) {
    let url = config.serverUrl + 'v2/gbcreaterefnofromupgradepremiumcms'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  gbprimecheckpaymentsuccess(data, callback) {
    let url = config.serverUrl + 'gbprimecheckpaymentsuccess'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getshopaddressarray(data, callback) {
    let url = config.serverUrl + 'shopaddressarray'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveshopaddressarray(data, callback) {
    let url = config.serverUrl + 'shopaddressarray'
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  astonclosetaskstimeperiodbyadmin(data, callback) {
    let url = config.serverUrl + 'astonclosetaskstimeperiodbyadmin'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  astonclosetaskstimeperiodbypage(data, callback) {
    let url = config.serverUrl + 'astonclosetaskstimeperiodbypage'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveusersession(data, callback) {
    let url = config.serverUrl + 'usersession'
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAstonAdmins(data, callback) {
    let url = config.serverUrl + 'astonadmins'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveuseradminname(data, callback) {
    let url = config.serverUrl + 'useradminname'
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  addastonadmin(data, callback) {
    let url = config.serverUrl + 'astonadmins'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveastonadmin(data, callback) {
    let url = config.serverUrl + 'astonadmins'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteAstonAdmin(data, callback) {
    let url = config.serverUrl + 'astonadmins'
    axios
      .delete(url, { data: data.body })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  toggleFacebookSyncTags(data, callback) {
    let url = config.serverUrl + 'synctagsfacebook_status'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getchillpainai_influencer(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postchillpainai_influencer(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putchillpainai_influencer(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer'
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putchillpainai_influencer_password(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer_password'
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deletechillpainai_influencer(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer'
    axios
      .delete(url, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_total_users(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'total_users'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_total_users_calculate(data, callback) {
    let url = config.serverUrl + 'total_users_calculate'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_total_new_users(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'total_new_users'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_report_inbox_user_by_date(data, callback) {
    let url = config.serverUrlAws + 'report_inbox_user_by_date'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_report_comment_user_by_date(data, callback) {
    let url = config.serverUrlAws + 'report_comment_user_by_date'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_report_inbox_user_by_time(data, callback) {
    let url = config.serverUrlAws + 'report_inbox_user_by_time'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_report_comment_user_by_time(data, callback) {
    let url = config.serverUrlAws + 'report_comment_user_by_time'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_report_inbox_message(data, callback) {
    let url = config.serverUrlAws + 'report_inbox_message'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_report_comment_message(data, callback) {
    let url = config.serverUrlAws + 'report_comment_message'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_all_users(data, callback) {
    let url = `${config.serverUrlAws}all_users`
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_all_users_calculate(data, callback) {
    let url = `${config.serverUrlAws}all_users_calculate`
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  get_fb_broadcast_errors(data, callback) {
    let url = config.serverUrl + 'get_fb_broadcast_errors'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(
          { ...response, data: { ...response.data, responsecode: response.status } },
          callback
        )
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  get_line_broadcast_errors(data, callback) {
    let url = config.serverUrl + 'get_line_broadcast_errors'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(
          { ...response, data: { ...response.data, responsecode: response.status } },
          callback
        )
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  test_webchat(data, callback) {
    let url = config.serverUrl + 'test_webchat'
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getShippingcostdistance(data, callback) {
    let url = config.serverUrl + 'shippingcostdistance'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  eggCreateMerchant(data, callback) {
    let url = config.serverUrl + 'egg/create_merchant'
    axios.defaults.headers.common = {
      'api-key': '1-2-3-sharks-landed'
    }
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postShippingcostdistance(data, callback) {
    let url = config.serverUrl + 'shippingcostdistance'
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  eggPageConfig(data, callback) {
    let url = config.serverUrl + 'egg/page_config'
    axios.defaults.headers.common = {
      'api-key': '1-2-3-sharks-landed'
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(
          { ...response, data: { ...response.data, responsecode: response.status } },
          callback
        )
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putShippingcostdistance(data, callback) {
    let url = config.serverUrl + 'shippingcostdistance'
    axios
      .put(url, data.body, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  updateStatusEggPageConfig(data, callback) {
    let url = config.serverUrl + 'egg/page_config'
    axios.defaults.headers.common = {
      'api-key': '1-2-3-sharks-landed'
    }
    axios
      .put(url, data.body, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(
          { ...response, data: { ...response.data, responsecode: response.status } },
          callback
        )
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  generateOrderInvoice(data, callback) {
    let url = config.serverUrl + 'generate_order_invoice'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putPageReceiptConfig(data, callback) {
    let url = config.serverUrl + 'page_receipt_config'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getPageReceiptConfig(data, callback) {
    let url = config.serverUrl + 'page_receipt_config'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, {
        params: data
      })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getLineContentVideo(data, callback) {
    let url = config.serverUrl + `line/content/video/${data.page_id}/${data.message_id}`
    axios
      .get(url, {
        params: data,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  async getAliceProductAmount(data) {
    let url = config.serverUrl + `alice_cafe/product_amount_by_date`
    try {
      var response = await axios.get(url, {
        params: data,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async postSalePage(data) {
    let url = config.serverUrl + 'sale_page' + '/' + data.params.pageid
    axios.defaults.headers.common = {
      'api-key': '1-2-3-sharks-landed',
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.post(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async putSalePage(data) {
    let url = config.serverUrl + 'sale_page' + '/' + data.params.pageid
    axios.defaults.headers.common = {
      'api-key': '1-2-3-sharks-landed',
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.put(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async getSalePage(data) {
    let url = config.serverUrl + 'sale_page' + '/' + data.params.pageid
    axios.defaults.headers.common = {
      'api-key': '1-2-3-sharks-landed'
    }
    try {
      var response = await axios.get(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async setPaymentSlip(data) {
    let url = config.serverUrl + `page/${data.pageid}/config/payment_slip`
    try {
      var response = await axios.put(url, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async putAddonForm(data) {
    let url = config.serverUrl + `shop/${data.pageid}/addon_form`
    try {
      var response = await axios.put(url, data.body, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async userEditOrder(data) {
    let url = config.serverUrl + `page/${data.pageid}/config/allow-user-edit-order`
    try {
      var response = await axios.put(url, data.body, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async eggPrivacyNotice(data) {
    let url = config.serverUrl + `egg/seller/privacy_notice`
    try {
      var response = await axios.get(url, {
        params: data,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async eggTermAndCondition(data) {
    let url = config.serverUrl + `egg/seller/term_and_condition`
    try {
      var response = await axios.get(url, {
        params: data,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async post_productstock_batch(data, callback) {
    let url = config.serverUrl + `productstock_batch`
    try {
      var response = await axios.post(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      this.defaultResponse(response, callback)
    } catch (error) {
      this.defaultError(error, callback)
    }
  },
  async put_productstock_batch(data, callback) {
    let url = config.serverUrl + `productstock_batch`
    try {
      var response = await axios.put(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      this.defaultResponse(response, callback)
    } catch (error) {
      this.defaultError(error, callback)
    }
  },
  async delete_productstock_batch(data, callback) {
    let url = config.serverUrl + `productstock_batch`
    try {
      var response = await axios.delete(url, {
        params: data.params,
        data: data.body,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      this.defaultResponse(response, callback)
    } catch (error) {
      this.defaultError(error, callback)
    }
  },
  async post_productbundle_batch(data, callback) {
    let url = config.serverUrl + `productbundle_batch`
    try {
      var response = await axios.post(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      this.defaultResponse(response, callback)
    } catch (error) {
      this.defaultError(error, callback)
    }
  },
  async put_productbundle_batch(data, callback) {
    let url = config.serverUrl + `productbundle_batch`
    try {
      var response = await axios.put(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      this.defaultResponse(response, callback)
    } catch (error) {
      this.defaultError(error, callback)
    }
  },
  async delete_productbundle_batch(data, callback) {
    let url = config.serverUrl + `productbundle_batch`
    try {
      var response = await axios.delete(url, {
        params: data.params,
        data: data.body,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      this.defaultResponse(response, callback)
    } catch (error) {
      this.defaultError(error, callback)
    }
  },
  async admin_utm_source(data) {
    try {
      var response = await axios.put(`${config.serverUrl}admin/utm_source`, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  getIGPost: function(fburl) {
    return new Promise((resolve, reject) => {
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/' +
          store.state.selectedBot.instagram_business_account +
          '/media?access_token=' +
          store.state.selectedBot.page_access_token +
          '&fields=caption,id,media_url,media_type,is_comment_enabled,permalink'
      }
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getFbReelsPost: function(fburl, pageid) {
    return new Promise((resolve, reject) => {
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url = `https://graph.facebook.com/v12.0/${pageid}/video_reels?access_token=${store.state.selectedBot.page_access_token}&fields=description,updated_time,id,post_id`
      }
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  async post_packhai_save_token(data) {
    let url = config.serverUrl + `packhai/save-token`
    try {
      var response = await axios.post(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async post_packhai_update_stock_list(data) {
    let url = config.serverUrl + `packhai/update-stock-list`
    try {
      var response = await axios.post(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async post_packhai_create_new_order(data) {
    let url = config.serverUrl + `packhai/create-new-order`
    try {
      var response = await axios.post(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      return error.response.data
      // this.defaultError2(error)
    }
  },
  async delete_packhai_cancel_order(data) {
    let url = config.serverUrl + `packhai/cancel-order`
    try {
      var response = await axios.delete(url, {
        params: data.params,
        data: data.body,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async liveChatUserOrders(data) {
    let url = config.serverUrl + `livechat/user-orders`
    try {
      var response = await axios.get(url, {
        params: data,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async liveChatUserCart(data) {
    let url = config.serverUrl + `livechat/user-cart`
    try {
      var response = await axios.get(url, {
        params: data,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async welcomeChecklist(pageid) {
    let url = config.serverUrl + `page/${pageid}/check-list`
    try {
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async platFormAccountInfo() {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url =
      config.serverUrl + `admin/` + store.state.selectedBot.pageid + `/platform/account-info`
    try {
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getUserTagList() {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url =
      config.serverUrl +
      `page/` +
      store.state.selectedBot.pageid +
      `/user-tag-list?limit=1500&sort=createdat_desc`
    try {
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async deleteUserTagList(data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + `page/` + store.state.selectedBot.pageid + `/user-tag-list`
    try {
      var response = await axios.delete(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        },
        data: data.body
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async deleteUserStatusList(data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + `page/` + store.state.selectedBot.pageid + `/user-status-list`
    try {
      var response = await axios.delete(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        },
        data: data.body
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getUserStatusList() {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url =
      config.serverUrl +
      `page/` +
      store.state.selectedBot.pageid +
      `/user-status-list?limit=1000&sort=createdat_desc`
    try {
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async saveOrdersTracking(data) {
    var url =
      config.serverUrl + `order/` + store.state.selectedBot.pageid + '/update-order-tracking'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.put(url, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      return false
    }
  },

  async editGroupInfo(data) {
    var url =
      config.serverUrl +
      `livechat/` +
      store.state.selectedBot.pageid +
      '/line/' +
      data.group_id +
      '/edit-info'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.put(url, data.value, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async groupMemebers(data) {
    var url =
      config.serverUrl + `livechat/${store.state.selectedBot.pageid}/line/${data.group_id}/members`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.get(url, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async leaveGroup(data) {
    var url = config.serverUrl + `livechat/${data.pageId}/line/${data.groupId}/leave-group`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.delete(url, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      console.log(response)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async blockGroup(data) {
    var url =
      config.serverUrl +
      `livechat/${data.pageId}/line/${data.groupId}/block-group?type=${data.type}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.delete(url, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      console.log(response)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async toggleWeightShipping(data) {
    var url = config.serverUrl + `page/${data.pageId}/update-page-config`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.put(url, data.body, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async post_sokochan_save_token(data) {
    let url = config.serverUrl + `sokochan/${data.params.pageid}/save-config`
    try {
      var response = await axios.post(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async post_sokochan_create_new_order(data) {
    let url = config.serverUrl + `sokochan/${data.params.pageid}/create-new-order`
    try {
      var response = await axios.post(url, data.body, {
        params: data.params,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      return error.response
    }
  },

  async getFile(data) {
    let url = config.serverUrl + `line/content/file/${data.pageid}/${data.fileid}`
    try {
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async delete_sokochan_cancel_order(data) {
    let url = config.serverUrl + `sokochan/${data.params.pageid}/cancel-order`
    try {
      var response = await axios.delete(url, {
        params: data.params,
        data: data.body,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getBeaconsList(data) {
    let url =
      config.serverUrl +
      `line-beacon/${data.pageid}/config?limit=${data.limit}&offset=${data.offset}`
    try {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async postBeaconsList(data) {
    let url = config.serverUrl + `line-beacon/${data.pageid}/save-config`
    try {
      var response = await axios.post(url, data.body, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async deleteBeaconsList(data) {
    let url = config.serverUrl + `line-beacon/${data.pageid}/config/${data.config_id}`
    try {
      var response = await axios.delete(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async reportMessageBeaconsList(data) {
    let url = config.serverUrl + `line-beacon/${data.pageid}/report-message`
    try {
      var response = await axios.get(
        url,
        { params: data.params },
        {
          headers: {
            'api-key': '1-2-3-sharks-landed'
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async reportUserByDateBeaconsList(data) {
    let url = config.serverUrl + `line-beacon/${data.pageid}/report-user-by-date`
    try {
      var response = await axios.get(
        url,
        { params: data.params },
        {
          headers: {
            'api-key': '1-2-3-sharks-landed'
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async reportUserByTimeBeaconsList(data) {
    let url = config.serverUrl + `line-beacon/${data.pageid}/report-user-by-time`
    try {
      var response = await axios.get(
        url,
        { params: data.params },
        {
          headers: {
            'api-key': '1-2-3-sharks-landed'
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getAdmins(data) {
    let url = config.serverUrl + `page/${data.pageid}/admin-account`
    try {
      var response = await axios.get(
        url,
        { params: data.params },
        {
          headers: {
            'api-key': '1-2-3-sharks-landed'
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getShippopOrders(data) {
    let url = config.serverUrl + `ordersummary`
    try {
      var response = await axios.get(
        url,
        { params: data },
        {
          headers: {
            'api-key': '1-2-3-sharks-landed'
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async checkTokenStatus(data) {
    let url = `${config.serverUrl}gbprime/${data.pageid}/check-token-status`
    try {
      var response = await axios.post(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getInstagramDetail() {
    let url = `https://graph.facebook.com/v12.0/me?fields=id,name,instagram_business_account.fields(id,name,username,profile_picture_url)&access_token=${store.state.selectedBot.page_access_token}`
    try {
      var response = await axios.get(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async createadminuser(data) {
    let url = config.serverUrl + `page/${data.pageid}/admin-account`
    try {
      var response = await axios.post(url, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async createCustomAudience(data) {
    let url = config.serverUrl + `page/${data.pageid}/facebook-ad/custom-audience`
    try {
      var response = await axios.post(url, data.body, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      return await this.defaultError2(error)
    }
  },

  async createCustomAudience2(data) {
    let url = config.serverUrlAws + `page/${data.pageid}/facebook-ad/v2/custom-audience`
    try {
      var response = await axios.post(url, data.body, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      return await this.defaultError2(error)
    }
  },

  async checkCreateCustomAudience(data) {
    let url =
      config.serverUrlAws + `page/${data.pageid}/facebook-ad/v2/check-create-custom-audience`
    try {
      var response = await axios.post(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      return await this.defaultError2(error)
    }
  },

  async updateCustomAudience(data) {
    let url =
      config.serverUrl + `page/${data.pageid}/facebook-ad/custom-audience/${data.audience_id}`
    try {
      var response = await axios.put(url, data.body, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async changeprivilegeadminuser(data) {
    let url = config.serverUrl + `page/${data.pageid}/admin-account/${data.userid}`
    try {
      var response = await axios.put(url, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async removeItemsInCart(data) {
    let url = config.serverUrl + `cart/${data.pageid}/${data.userid}/remove-items`
    try {
      var response = await axios.delete(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        },
        data: { cart_ids: data.cart_ids }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async deleteadminusers(data) {
    let url = config.serverUrl + `page/${data.pageid}/admin-account/${data.userid}`
    try {
      var response = await axios.delete(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async updatePageConfig(data) {
    let url = config.serverUrl + 'page/' + data.pageid + '/update-page-config'
    try {
      var response = await axios.put(url, data.body, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
      return { success: false }
    }
  },

  async getCustomAudience(data) {
    let url = config.serverUrl + 'page/' + data.pageid + '/facebook-ad/custom-audience'
    try {
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async deleteCustomAudience(data) {
    let url = `${config.serverUrl}page/${data.pageid}/facebook-ad/custom-audience/${data.id}`
    try {
      var response = await axios.delete(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async createCartToken(data) {
    let url = `${config.serverUrl}gbprime/${data.pageid}/create-card-token`
    try {
      var response = await axios.post(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getZortout(data) {
    let url = `${config.serverUrl}zortout/${data.pageid}/config`
    try {
      var response = await axios.get(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async putZortout(data) {
    let url = `${config.serverUrl}zortout/${data.pageid}/config`
    try {
      var response = await axios.put(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
      return { success: false }
    }
  },

  async generateZortoutToken(data) {
    let url = `${config.serverUrl}zortout/${data.pageid}/generate-api-token`
    try {
      var response = await axios.get(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async createCharge(data) {
    let url = `${config.serverUrl}gbprime/${data.pageid}/create-charge`
    try {
      var response = await axios.post(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async getCheckList(data) {
    let url = config.serverUrl + 'page/' + data.pageid + '/check-list'
    try {
      var response = await axios.get(url, {
        params: data.params
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async createLiveAuction(data) {
    let url = `${config.serverUrl}auction/${data.pageid}`
    try {
      var response = await axios.post(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async editLiveAuction(data) {
    let url = `${config.serverUrl}auction/${data.pageid}/${data.auctionid}`
    try {
      var response = await axios.put(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async editLiveProductAuction(data) {
    let url = `${config.serverUrl}auction/${data.pageId}/${data.auctionId}/products/${data.productId}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.put(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async getLiveAuction(data) {
    let url = `${config.serverUrl}auction/${data.pageid}`
    try {
      var response = await axios.get(url, {
        params: data.params
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async getProductsLiveAuction(data) {
    let url = `${config.serverUrl}auction/${data.pageId}/${data.auctionId}/products`
    try {
      var response = await axios.get(url, {
        params: data.params
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async getLiveAuctionByID(data) {
    let url = `${config.serverUrl}auction/${data.pageid}/${data.auctionID}`
    try {
      var response = await axios.get(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async deleteLiveAuctionByID(data) {
    let url = `${config.serverUrl}auction/${data.pageid}/${data.auctionID}`
    try {
      var response = await axios.delete(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getAdminInfo(data) {
    let url = `${config.serverUrl}admin/${data.pageId}/${data.adminId}/info`
    try {
      var response = await axios.get(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async getAdsSimulator(data) {
    let url = `${config.serverUrl}page/${data.pageId}/messenger-ads-simulator`
    try {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      var response = await axios.get(url, {
        params: data.params
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getCustomerBidder(data) {
    let url = `${config.serverUrl}auction/${data.pageId}/${data.auctionId}/products/${data.productId}/bidder`
    try {
      var response = await axios.get(url, { params: data.param })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async bannedCustomer(data) {
    let url = `${config.serverUrl}auction/${data.pageId}/${data.auctionId}/products/${data.productId}/bidder/${data.userId}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.put(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async deleteCustomer(data) {
    let url = `${config.serverUrl}auction/${data.pageId}/${data.auctionId}/products/${data.productId}/bidder/${data.userId}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      var response = await axios.delete(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async closeAuctionById(data) {
    let url = `${config.serverUrl}auction/${data.pageId}/${data.auctionId}/products/${data.productId}/close-auction`
    try {
      var response = await axios.post(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async closeAllAuction(data) {
    let url = `${config.serverUrl}auction/${data.pageId}/${data.auctionId}/close-all-auction`
    try {
      var response = await axios.post(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async updateProductAuction(data) {
    let url = `${config.serverUrl}auction/${data.pageId}/${data.auctionId}/update-product`
    try {
      var response = await axios.post(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async updateAdsSimulator(data) {
    let url = `${config.serverUrl}page/${data.pageId}/messenger-ads-simulator`
    try {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      var response = await axios.post(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      return error.response
    }
  },

  async editAdsSimulator(data) {
    let url = `${config.serverUrl}page/${data.pageId}/messenger-ads-simulator/${data.adsId}`
    try {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      var response = await axios.put(url, data.body)
      return await this.defaultResponse2(response)
    } catch (error) {
      return error.response
    }
  },

  async deleteAdsSimulator(data) {
    let url = `${config.serverUrl}page/${data.pageId}/messenger-ads-simulator/${data.adsId}`
    try {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      var response = await axios.delete(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async getTagSummary(data) {
    const vm = this
    let url = `${config.serverUrl}aston/${data.pageId}/tag-summary`
    try {
      const response = await axios.get(url, { params: data.params })
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async generateAdminToken(data) {
    const vm = this
    let url = `${config.serverUrl}shop/${data.pageId}/generate-admin-token`
    try {
      let response = await axios.post(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async getGoogleApiCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}google-api/${data.pageId}/config`
    try {
      let response = await axios.get(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async editGoogleApiCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}google-api/${data.pageId}/config`
    try {
      let response = await axios.put(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async getBookingConfigCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config`
    try {
      let response = await axios.get(url, { params: data.params })
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async putBookingConfigCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config/${data.booking_config_id}`
    try {
      let response = await axios.put(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async postBookingConfigCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config`
    try {
      let response = await axios.post(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async deleteBookingConfigCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config/${data.booking_config_id}`
    try {
      let response = await axios.delete(url)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },

  async getSubBookingConfigCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config/${data.booking_config_id}/booking-info`
    try {
      let response = await axios.get(url, { params: data.params })
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async putSubBookingConfigCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config/${data.booking_config_id}/booking-info/${data.sub_booking_config_id}`
    try {
      let response = await axios.put(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async postSubBookingConfigCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config/${data.booking_config_id}/booking-info-batch`
    try {
      let response = await axios.post(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async deleteSubBookingConfigCalendar(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config/${data.booking_config_id}/booking-info/${data.sub_booking_config_id}`
    try {
      let response = await axios.delete(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async getBookingCalendarUser(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config/${data.booking_config_id}/booking-info/${data.sub_booking_config_id}/users`
    try {
      let response = await axios.get(url)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async deleteBookingCalendarUser(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/booking-config/${data.booking_config_id}/booking-info/${data.sub_booking_config_id}/users/${data.userid}`
    try {
      let response = await axios.delete(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async exportBooking(data) {
    const vm = this
    let url = `${config.serverUrl}booking/${data.pageId}/export-booking`
    try {
      let response = await axios.post(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async getLineMyShopConfig(data) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.pageId}/config`
    try {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      let response = await axios.get(url)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async putLineMyShopConfig(data) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.pageId}/config`
    try {
      let response = await axios.put(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async getProductLineMyShop(data, callback) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.pageid}/products?page=${data.page}&perPage=${
      data.limit
    }${data.skus ? `&skus=${data.skus}` : ''}`
    try {
      let response = await axios.get(url, data.body)
      callback(null, response)
    } catch (error) {
      callback(error.response, null)
    }
  },
  async getAllOrdersLineMyShop(data) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.pageid}/orders`
    try {
      let response = await axios.get(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async getOrdersDeatailLineMyShop(data) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.pageid}/orders/${data.orderNo}`
    try {
      let response = await axios.get(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async decreaseProductLineMyShop(data) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.pageid}/inventory/${data.inventory_id}/decrease`
    try {
      let response = await axios.put(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async increaseProductLineMyShop(data) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.pageid}/inventory/${data.inventory_id}/increase`
    try {
      let response = await axios.put(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async get_line_order_messages(data) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.pageid}/messages`
    try {
      let response = await axios.get(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },
  async put_line_order_messages(data) {
    const vm = this
    let url = `${config.serverUrl}line-my-shop/${data.params.pageid}/update_messages`
    try {
      let response = await axios.put(url, data.body)
      return await vm.defaultResponse2(response)
    } catch (error) {
      vm.defaultError2(error)
    }
  },

  // end
  // =============== default function =================
  async defaultResponse2(response) {
    var { reason } = response.data
    reason = reason || ''
    if (response.status == 200) {
      return response.data
    } else {
      if (response.status && response.status == 401) await this.forceLogout(response, reason)
      let error = new Error(
        (response.status ? response.status + ': ' : '') +
          (reason || 'Session expire. Please login again.')
      )
      error.response = response
      throw error
    }
  },

  async defaultError2(error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(error)
    }
    if (error.response && error.response.status == 401) {
      let reason =
        'Session Expire, Please try to log in again. เกิดข้อผิดพลาด หรือ อาจมีการล็อกอินซ้อน กรุณาล็อกอินใหม่อีกครั้ง'
      if (error.response.data && error.response.data.message) {
        reason = e.response.data.message
      }
      this.forceLogout(error.response, reason).then(() => {
        // throw error
      })
    } else {
      // throw error
    }
    return error
  },

  defaultResponse: function(response, callback) {
    // store.dispatch('logout', { 'code': '400', 'message': 'Session expire. Please login again.'  }).then(function(){
    // 	router.push('/login')

    // })
    response = response.data
    if (response.responsecode === 200) {
      callback(null, response)
    } else if (response.success) {
      callback(null, response.result)
    } else if (response.responsecode === 400) {
      let message = response.reason ? response.reason : ''
      if (store.state.userid == '1553371411367438') alert(`${response.responsecode} - ${message}`)
      // console.log('before',isFacebook)
      this.forceLogout(response, message).then(() => {
        callback(new Error('Session expire. Please login again.'))
      })
    } else if (response.responsecode === 422) {
      Swal.fire({
        title: 'เกิดข้อผิดพลาด',
        text: response && response.reason ? response.reason.replace(/_/g, ' ') : '',
        type: 'error',
        confirmButtonText: 'ยืนยัน',
        reverseButtons: true
      })
      callback(new Error(response.reason), response)
    } else {
      // console.log(response)
      if (response.reason) {
        callback(new Error(response.reason), response)
      } else {
      }
    }
  },

  defaultError: function(e, callback) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(e)
    }
    if (e.response && e.response.status == 401) {
      let reason =
        'Session Expire, Please try to log in again. เกิดข้อผิดพลาด หรือ อาจมีการล็อกอินซ้อน กรุณาล็อกอินใหม่อีกครั้ง'
      // if (e.response.data.message) {
      //   reason = e.response.data.message
      // }
      this.forceLogout(e.response, reason).then(() => {
        callback(new Error('Session expire. Please login again.'), e)
      })
    } else {
      callback(e, e)
    }
  },

  joinFilter: function(data, isPremium) {
    var url = []
    if (data['gender']) {
      url.push('gender=' + data['gender'].value)
    }
    if (data['fullname']) {
      url.push('fullname=' + data['fullname'])
    }
    if (data['app']) {
      if (data['app'].value !== 'all') {
        url.push('app=' + data['app'].value)
      }
    }
    if (data['locale'] && data['locale'].length > 0) {
      var locales = []
      if (data['locale']) {
        data['locale'].map(function(locale, index) {
          locales.push(locale.value)
        })
      }
      url.push('locale=' + locales.join(','))
    }
    if (data['tags']) {
      url.push('tags=' + data['tags'])
    }
    if (data['tags_include']) {
      url.push('tags_include=' + data['tags_include'])
    }
    if (data['tags_exclude']) {
      url.push('tags_exclude=' + data['tags_exclude'])
    }
    if (data['statustype']) {
      url.push('statustype=' + data['statustype'])
    }
    if (data['activeDate']['start']) {
      url.push('timestamp_from=' + dayjs(data['activeDate']['start']).format('YYYY-MM-DD'))
    }
    if (data['activeDate']['end']) {
      url.push('timestamp_to=' + dayjs(data['activeDate']['end']).format('YYYY-MM-DD'))
    }
    if (data['registerDate']['start']) {
      url.push(
        'registertimestamp_from=' + dayjs(data['registerDate']['start']).format('YYYY-MM-DD')
      )
    }
    if (data['registerDate']['end']) {
      url.push('registertimestamp_to=' + dayjs(data['registerDate']['end']).format('YYYY-MM-DD'))
    }
    if (data['lineid']) {
      url.push('lineid=' + data['lineid'])
    }
    if (data['school']) {
      url.push('school=' + data['school'].name)
    }
    if (data['province']) {
      url.push('province=' + data['province'])
    }
    if (data['specialcondition']) {
      url.push('specialcondition=' + data['specialcondition'].value)
    }
    if (data['exclude_broadcast_ids']) {
      url.push('exclude_broadcast_ids=' + `[${data['exclude_broadcast_ids'].join(',')}]`)
    }

    if (isPremium) {
      if (data['email']) {
        url.push('email=' + data['email'])
      }
      if (data['context']) {
        url.push('context=' + data['context'])
      }
      if (data['phoneno']) {
        url.push('phoneno=' + data['phoneno'])
      }
      if (data['status'] && data['status'].length > 0) {
        url.push('status=' + data['status'])
      }
      if (data['intent'] && data['intent'].length > 0) {
        url.push('intent=' + data['intent'].join(','))
      }
      if (data['timezone']['from'] || data['timezone']['to']) {
        var timezone = []
        if (data['timezone']['from']) {
          timezone.push(data['timezone']['from'])
        }
        if (data['timezone']['to']) {
          timezone.push(data['timezone']['to'])
        }
        url.push('timezone=' + timezone.join(','))
      }
    }

    return url.join('&')
  },
  joinFilterToObject: function(data, isPremium) {
    var filter = {}
    if (data['gender']) {
      Object.assign(filter, { gender: data['gender'].value })
    }
    if (data['fullname']) {
      Object.assign(filter, { fullname: data['fullname'] })
    }
    if (data['app']) {
      if (data['app'].value !== 'all') {
        Object.assign(filter, { app: data['app'].value })
      }
    }
    if (data['locale'] && data['locale'].length > 0) {
      var locales = []
      if (data['locale']) {
        data['locale'].map(function(locale, index) {
          locales.push(locale.value)
        })
      }
      Object.assign(filter, { locale: locales.join(',') })
    }
    if (data['tags']) {
      Object.assign(filter, { tags: data['tags'] })
    }
    if (data['statustype']) {
      Object.assign(filter, { statustype: data['statustype'] })
    }
    if (data['activeDate']['start']) {
      Object.assign(filter, {
        timestamp_from: dayjs(data['activeDate']['start']).format('YYYY-MM-DD')
      })
    }
    if (data['activeDate']['end']) {
      Object.assign(filter, {
        timestamp_to: dayjs(data['activeDate']['end']).format('YYYY-MM-DD')
      })
    }
    if (data['registerDate']['start']) {
      Object.assign(filter, {
        registertimestamp_from: dayjs(data['registerDate']['start']).format('YYYY-MM-DD')
      })
    }
    if (data['registerDate']['end']) {
      Object.assign(filter, {
        registertimestamp_to: dayjs(data['registerDate']['end']).format('YYYY-MM-DD')
      })
    }
    if (data['lineid']) {
      Object.assign(filter, { lineid: data['lineid'] })
    }
    if (data['school']) {
      Object.assign(filter, { school: data['school'].name })
    }
    if (data['province']) {
      Object.assign(filter, { province: data['province'] })
    }
    if (data['specialcondition']) {
      Object.assign(filter, { specialcondition: data['specialcondition'].value })
    }

    if (isPremium) {
      if (data['email']) {
        Object.assign(filter, { email: data['email'] })
      }
      if (data['context']) {
        Object.assign(filter, { context: data['context'] })
      }
      if (data['phoneno']) {
        Object.assign(filter, { phoneno: data['phoneno'] })
      }
      if (data['status'] && data['status'].length > 0) {
        Object.assign(filter, { status: data['status'] })
      }
      if (data['intent'] && data['intent'].length > 0) {
        Object.assign(filter, { intent: data['intent'].join(',') })
      }
      if (data['timezone']['from'] || data['timezone']['to']) {
        var timezone = []
        if (data['timezone']['from']) {
          timezone.push(data['timezone']['from'])
        }
        if (data['timezone']['to']) {
          timezone.push(data['timezone']['to'])
        }
        Object.assign(filter, { timezone: timezone.join(',') })
      }
    }
    return filter
  },
  async forceLogout(response, reason) {
    var isFacebook = store.state.isFacebook

    await store.dispatch('logout', { code: response.status, message: reason })

    if (
      router.history.current.name !== 'login' ||
      router.history.current.name !== 'nigol' ||
      router.history.current.name !== 'iconkaset' ||
      router.history.current.name !== 'meta'
    ) {
      if (isFacebook) {
        router.push({
          path: '/' + store.getters.currentLang + '/login',
          query: router.query
        })
      } else {
        if (store.state.privilege.role === 'admin') {
          router.push({
            path: '/' + store.getters.currentLang + '/iconkaset',
            query: router.query
          })
        } else if (store.state.userid === 'metateam') {
          router.push('/' + store.getters.currentLang + '/meta').catch(() => {})
        } else {
          router.push({
            path: '/' + store.getters.currentLang + '/nigol',
            query: router.query
          })
        }
      }
    }
  },
  getAdminPageInfo: function(callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .get(`${config.serverUrl}page/${store.getters.selectedBot.pageid}/admin-page-info`)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveAdminPageInfo: function(payload, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .post(`${config.serverUrl}page/${store.getters.selectedBot.pageid}/admin-page-info`, payload)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
}



// WEBPACK FOOTER //
// ./src/api/index.js